// Export CSV natif — aucune dépendance. Séparateur « ; » et BOM UTF-8 pour
// qu'Excel (config FR) ouvre correctement les accents et les colonnes.

const escapeCell = (value) => {
  if (value === null || value === undefined) return '';
  const text = String(value);
  return /[";\n\r]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
};

/**
 * @param {Array<{title: string, value: (row) => any}>} columns
 * @param {Array<object>} rows
 */
export const toCsv = (columns, rows) => {
  const header = columns.map((c) => escapeCell(c.title)).join(';');
  const body = rows.map((row) => columns.map((c) => escapeCell(c.value(row))).join(';')).join('\r\n');
  return `﻿${header}\r\n${body}`;
};

export const downloadCsv = (filename, content) => {
  const blob = new Blob([content], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
